import React from 'react';
import Hero from '../Components/Hero';
import HowItWorks from '../Components/HowItWorks';
import WhyChoose from '../Components/WhyChoose';
import Pricing from '../Components/Pricing';
import Faq from '../Components/faq';
import Dftj from '../Components/Dftj';
// import MarketingPopup from '../Components/MarketingPopup';

type HomeProps = {
  setCurrentPage: React.Dispatch<React.SetStateAction<string>>;
};

const Home: React.FC<HomeProps> = ({ setCurrentPage }) => {
  return (
    <main>
      {/* Hero section */}
      <Hero setCurrentPage={setCurrentPage} />
      {/* Marketing pop-up */}
      { /*<MarketingPopup /> */}
      {/* How It Works */}
      <HowItWorks />
      {/* Why Choose ExamCompass */}
      <WhyChoose />
      {/* Pricing */}
      <Pricing />
      {/* FAQs */}
      <Faq />
      {/* Don't forget to join */}
      <Dftj />
    </main>
  );
};

export default Home;
